export default __webpack_public_path__ + "static/media/disk.d81ed0b7.ogg";